import { render, staticRenderFns } from "./FAlert.vue?vue&type=template&id=19fe4660&scoped=true&"
import script from "./FAlert.vue?vue&type=script&lang=js&"
export * from "./FAlert.vue?vue&type=script&lang=js&"
import style0 from "./FAlert.vue?vue&type=style&index=0&id=19fe4660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fe4660",
  null
  
)

export default component.exports